function isMobile(): boolean {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // List of mobile user agents
  const mobileUserAgents = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  // Check if the user agent matches any of the mobile user agents
  return mobileUserAgents.some((mobileAgent) => userAgent.match(mobileAgent));
}

const mobileSearchInit = (item: HTMLElement) => {
  const searchToggle = item.querySelector('.aa-Autocomplete');

  if (isMobile()) {
    searchToggle.addEventListener('click', () => {
      setTimeout(() => {
        const input : HTMLInputElement = document.querySelector('.aa-Input');
        input.focus();

        input.dispatchEvent(new Event('touchend', { bubbles: true }));
        input.dispatchEvent(new Event('click', { bubbles: true }));
      }, 200);
    });
  }
};

export default mobileSearchInit;
